import React from 'react';
import styles from '@dazn/lp-web/src/components/ComingUpRail/comingUp.module.css';
import { tileTypeConfig } from '@dazn/lp-web/src/utils/tileConfig';
import SimpleResponsiveImage from '@dazn/lp-web/src/components/Images/SimpleResponsiveImage/SimpleResponsiveImage';
import { animated } from '@react-spring/web';
import { useTileTransitions } from '@dazn/lp-web/src/hooks/useTransitions';
import { IComingUpTile } from '@dazn/lp-web/src/types/rail.types';
import { useLandingPagesContext } from '@dazn/lp-web/src/contexts/LandingPageContext';
import { getButtonLabel } from './comingUp.utils';
import { triggerElementClick } from '@dazn/lp-web/src/analytics/fe-events';
import { elementClickEventTypes } from '@dazn/lp-web/src/analytics/fe-events/elementClick';
import isQueryParamTrue from '../../utils/isQueryparamTrue';
import classNames from 'classnames';
interface IComingUpTileProps {
    tile: IComingUpTile;
    index: number;
    slidesPerView: number;
    disableAnimation: boolean;
}

const ComingUpTile: React.FC<IComingUpTileProps> = ({
    tile,
    index,
    slidesPerView,
    disableAnimation = false,
}) => {
    const [refView, springs] = useTileTransitions();
    const { offers, getPromoCodeByEntSetId } = useLandingPagesContext();
    const buttonLabel = getButtonLabel(tile?.button, offers);

    const animations = (() => {
        if (index >= slidesPerView || isQueryParamTrue('seo')) return {};

        return {
            style: springs,
            ref: refView
        };
    })();

    const handleTileButtonClick = () => {
        triggerElementClick({
            section: elementClickEventTypes.BODY,
            itemId: tile?.button?.entitlementSetId
                ? `${tile?.button?.entitlementSetId}_lp_comingup_cta`
                : '_lp_comingup_cta',
            resourceString: `${buttonLabel}-${tile?.title}`
        });

        if (tile.button?.action) {
            const entSetId = tile?.button?.entitlementSetId;
            const promoCode = getPromoCodeByEntSetId(entSetId);
            tile.button?.action({ promoCode });
        }
    };

    return (
        <animated.article {...(disableAnimation ? {} : animations)}>
            <div
                className={styles.comingUpTile}
                onClick={handleTileButtonClick}
            >
                <SimpleResponsiveImage
                    imageUrl={`${tile?.image.src}`}
                    aspectRatio={tileTypeConfig.PORTRAIT.aspectRatio}
                />
                <div className={styles.container}>
                    {tile?.showBadge && tile?.badgeText && (
                        <div className={styles.badge}>{tile.badgeText}</div>
                    )}
                    {tile?.title && (
                        <p className={styles.title}>{tile.title}</p>
                    )}
                    {buttonLabel &&
                        (isQueryParamTrue('seo') ? (
                            <a
                                href={tile?.button?.navigationLink ?? ''}
                                className={classNames(
                                    styles.button,
                                    'seoButton'
                                )}
                            >
                                {buttonLabel}
                            </a>
                        ) : (
                            <button className={styles.button}>
                                {buttonLabel}
                            </button>
                        ))}
                </div>
            </div>
        </animated.article>
    );
};

export default ComingUpTile;
